import { emission_certificate_energy_source_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateEmissionCertificateEnergySourceTypeEnum = (
  enumValue: emission_certificate_energy_source_type_enum,
) => {
  switch (enumValue) {
    case emission_certificate_energy_source_type_enum.DISTRICT_HEATING:
      return <Trans i18nKey="Enum_EmissionCertificateEnergySourceTypeEnum-DISTRICT_HEATING" />;
    case emission_certificate_energy_source_type_enum.ELECTRICITY_GREEN:
      return <Trans i18nKey="Enum_EmissionCertificateEnergySourceTypeEnum-ELECTRICITY_GREEN" />;
    case emission_certificate_energy_source_type_enum.ELECTRICITY_MIX:
      return <Trans i18nKey="Enum_EmissionCertificateEnergySourceTypeEnum-ELECTRICITY_MIX" />;
  }
};

export const translateEmissionCertificateEnergySourceTypeEnum_dynamic = (
  enumValue: emission_certificate_energy_source_type_enum,
) => {
  const t = getI18n().t;
  switch (enumValue) {
    case emission_certificate_energy_source_type_enum.DISTRICT_HEATING:
      return t('Enum_EmissionCertificateEnergySourceTypeEnum-DISTRICT_HEATING');
    case emission_certificate_energy_source_type_enum.ELECTRICITY_GREEN:
      return t('Enum_EmissionCertificateEnergySourceTypeEnum-ELECTRICITY_GREEN');
    case emission_certificate_energy_source_type_enum.ELECTRICITY_MIX:
      return t('Enum_EmissionCertificateEnergySourceTypeEnum-ELECTRICITY_MIX');
  }
};
